import languages from '../utils/languages';
import NotInstalledDialog from '../components/notIntalledDialog';
import { showDialog } from '../pages/page';
import { isFlagOn } from '../utils/flags';
import { checkExtensionIsInstalledAsync } from '../../react/utils/chrome-extension';

/**
 * 
 * @param {'tour'|'hint'|'visualEvents'|'event'} type
 * @param {any} url
 * @param {any} onClosedCallback
 */
export function openEditor(type, baseUrl, id, onClosedCallback, skipInstallCheck = false, forceLegacyExtension = false) {
    if (window.auth.isInTrialAndExpired) {
        showDialog('trial-expired-dialog');

        return;
    }

    if (!forceLegacyExtension && !isFlagOn('lgc_xtsn_brd')) {
        checkExtensionIsInstalledAsync().then(isInstalled => {
            showDialog('new-extension-dialog', { isInstalled, id, type });
        });

        return;
    }

    if (localStorage.getItem('pf_should_install_ext')) {
        showDialog('should-install-extension');

        return;
    }

    if ((window.auth.project && window.auth.project.SnippetInstalled) || skipInstallCheck) {

        let finalUrl = baseUrl;

        if (isFlagOn('edtr_prmt')) {
            const u = new URL(finalUrl);
            u.searchParams.append('pfEditor', '1');
            finalUrl = u.toString();
        }

        const editorWindow = window.open(
            finalUrl,
            'productfruits-editor-window' + (isFlagOn('editor_new_save') ? '-' + type + id : ''),
            'toolbar=no, menubar=no, resizable=yes, left=1, top=1, width=' + screen.availWidth + ', height=' + screen.availHeight);

        if (!editorWindow) {
            alert('It seems like our editor was blocked by your browser. Allow pop-up windows for app.productfruits.com to be able to use Product Fruits editor.');
            return;
        }

        const handler = (e) => {
            if (isFlagOn('edtr_mtdm') && editorWindow.closed) {
                window.removeEventListener('message', handler);
            }
            if (e.data.action === 'getFeature') {
                editorWindow.postMessage({
                    action: type == 'tour' ? 'setTour' : type == 'visualEvents' ? 'setVisualEvent' : 'setContextHelp',
                    id: id,
                    supportedLanguages: languages.filter(i => window.auth.project.SupportedLanguages.indexOf(i.alpha2) !== -1)
                }, '*');

                if (!isFlagOn('edtr_mtdm')) {
                    window.removeEventListener('message', handler);
                }
            }
        }

        window.addEventListener('message', handler);

        const timer = setInterval(() => {
            if (editorWindow.closed) {
                clearInterval(timer);

                if (onClosedCallback) onClosedCallback();
            }
        }, 650);
    } else {
        showDialog(NotInstalledDialog({
            action: () => { openEditor(type, baseUrl, id, onClosedCallback, true); }
        }));
    }
}